import styled from "styled-components";
import Footer from "../loggedOut/landingPage/Footer";
import { useContext } from "react";
import Context from "../../../Context";
import { useTranslation } from "react-i18next";
import LoginWall from "./LoginWall";
import SwipeBack from "./SwipeBackGesture";
import AnimatedPage from "./AnimatedPage";
import LoggedInTopBar from "./LoggedInTopBar";

const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Gap = styled.div`
  display: flex;
  height: 100px;
`;

export default function LoggedInBoilerplate({
  children,
  showFooter,
  allowWithoutLogin,
  titleLine1,
  titleLine2,
  showBackButton,
  rightSlot,
}) {
  const { loggedInUserID } = useContext(Context);
  const { t } = useTranslation();

  if (!loggedInUserID && !allowWithoutLogin) return <LoginWall />;

  return (
    <SwipeBack>
      <AnimatedPage>
        <Main>
          <LoggedInTopBar
            showBackButton={showBackButton}
            titleLine1={titleLine1}
            titleLine2={titleLine2}
            rightSlot={rightSlot}
          />
          {children}
          <Gap />
          {showFooter ? <Footer /> : null}
        </Main>
      </AnimatedPage>
    </SwipeBack>
  );
}
